import { AppConfig } from '@intelliarts/ia-react-template';

import routesConfig from './routesConfig';
import authConfig from './authConfig';
import { locales } from '../locales';

const config: AppConfig = {
  appName: 'Employees',
  defaultRedirectUrl: '/not-found-page',
  rootRedirectUrl: '/employees',
  logoRedirectUrl: '/employees',
  routes: routesConfig,
  auth: authConfig,
  withReduxLogger: false,
  locales: locales,
};

export default config;
